var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { GameListEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { SourceType } from "../../../../../models/queries/queries.models";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { Router } from "aurelia-router";
import { RouterConstants } from "../../../../../configuration/router.constants";
var LotteryOperatorDialog = /** @class */ (function (_super) {
    __extends(LotteryOperatorDialog, _super);
    function LotteryOperatorDialog(notificationService, i18N, queriesService, router, dialogClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.notificationService = notificationService;
        _this.queriesService = queriesService;
        _this.router = router;
        _this.dialogClient = dialogClient;
        _this.removeLastVisitedTabCache = true;
        _this.isBrand = false;
        _this.isOperator = true;
        _this.lottery = GameListEnum.Lottery;
        _this.instantGame = GameListEnum.InstantGame;
        _this.bundle = GameListEnum.Bundle;
        return _this;
    }
    LotteryOperatorDialog.prototype.close = function () {
        this.dialogClient.hide();
    };
    LotteryOperatorDialog.prototype.onActivated = function (brandItem) {
        if (!brandItem.disableLottery) {
            this.showList(brandItem, this.lottery);
        }
        else if (!brandItem.disableInstantGame) {
            this.showList(brandItem, this.instantGame);
        }
        else if (!brandItem.disableBundle) {
            this.showList(brandItem, this.bundle);
        }
    };
    // gets the list of instant games/lottery/bundle that they currency is not set
    LotteryOperatorDialog.prototype.showList = function (brand, searchByTerm) {
        this.GetGamesThatDontHaveCurrency(brand, searchByTerm);
    };
    LotteryOperatorDialog.prototype.GetGamesThatDontHaveCurrency = function (brand, searchByTerm) {
        var _this = this;
        var Uri = "GameListDoesNotHaveCurrencies";
        this.queriesService.getEntityModels().then(function (models) { return __awaiter(_this, void 0, void 0, function () {
            var columns, selectedModel, _a, _b, item, column;
            var e_1, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        columns = [];
                        selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == Uri; });
                        try {
                            for (_a = __values(selectedModel.projectionProperties), _b = _a.next(); !_b.done; _b = _a.next()) {
                                item = _b.value;
                                column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                                if (column.name.toLowerCase().includes(searchByTerm.toLowerCase()) || column.name == "lotteryPricingModelId") {
                                    columns.push(column);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, this.createDataGridList(brand, searchByTerm, columns)];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        }); }).catch(function (error) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
        });
    };
    LotteryOperatorDialog.prototype.createDataGridList = function (brand, searchByTerm, columns) {
        return __awaiter(this, void 0, void 0, function () {
            var oDataUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchByTerm = "show" + searchByTerm; // ceate parameter as showLottery or showInstantGame or showBundle to call sql function by clicking button
                        oDataUrl = "/odata/GameListDoesNotHaveCurrencies?brandId=".concat(brand.brandId, "&currencyId=").concat(brand.ticketPriceCurrencyId, "&").concat(searchByTerm, "=1");
                        return [4 /*yield*/, this.queriesService.getData(oDataUrl).then(function (response) {
                                _this.itemSource = {
                                    source: response.value,
                                    sourceType: SourceType.Collection,
                                    columns: columns,
                                    groupInitialFilters: true
                                };
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.itemSource.source.length];
                }
            });
        });
    };
    LotteryOperatorDialog.prototype.onItemSelected = function (eventOnDoubleClick) {
        var item = eventOnDoubleClick.detail.item;
        this.removeLastVisitedTabCache = false;
        if (item.lotteryId != null) {
            window.open(this.router.generate(RouterConstants.RouteNames.ManageLottery, {
                id: item.lotteryId, brandId: item.brandId, brandName: item.brandName, operatorId: item.operatorId, operatorName: item.operator,
                brandTemplateInternalName: item.brandTemplateInternalName,
                brandThemeInternalName: item.brandThemeInternalName,
                brandDefaultCurrencyId: item.defaultCurrencyId,
                isOpenedFromLotteryAdmin: false,
                isOpenedFromBrandAdmin: false,
            }), '_blank');
        }
        else if (item.instantGameId != null) {
            window.open(this.router.generate(RouterConstants.RouteNames.ManageInstantGame, {
                id: item.instantGameId, brandId: item.brandId,
            }), '_blank');
        }
        else {
            window.open(this.router.generate(RouterConstants.RouteNames.ManageBundle, {
                id: item.bundleId, brandId: item.brandId,
            }), '_blank');
        }
    };
    LotteryOperatorDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            QueriesClientService, Router, DialogClientService])
    ], LotteryOperatorDialog);
    return LotteryOperatorDialog;
}(ChildComponent));
export { LotteryOperatorDialog };
